<template>
  <div class="page">
    <img :src="headImg" v-if="headImg" class="bg" alt="" />
    <div class="card">
      <div class="card_left">
        <div class="logo">
          <el-image
            :src="exData.Logo ? exData.Logo : require('@/assets/logo.png')"
            class="logo_img"
            fit="contain"
          ></el-image>
        </div>
      </div>

      <div class="card_right">
        <div class="name">{{ exData.CiComName }}</div>
        <div class="sub_name">展位号：{{ exData.ExtCode }}</div>
      </div>
    </div>
    <div class="introduce">
      <div class="w1200">
        <div class="title">公司介绍</div>
        <div class="sub_tit">
          {{ exData.CiIntro }}
        </div>
      </div>
    </div>

    <div class="content w1200" v-if="proList.length > 0">
      <div class="title">公司产品</div>
      <div class="card_box2">
        <div
          v-for="item in proList"
          :key="item.EpID"
          @click="bindProductDetails(item)"
          class="card_row"
        >
          <div class="bor"></div>
          <el-image
            :src="item.EpImage"
            v-if="item.EpImage"
            class="logo"
            fit="contain"
          ></el-image>
          <div class="card_right">
            <div class="name">{{ item.EpTitle }}</div>
            <div class="sub_name2">{{ item.EpInfo }}</div>
          </div>
        </div>
      </div>

      <div class="empty">
        <el-empty description="暂无" v-if="proList.length == 0"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobileDevice } from "@/utils/deviceCheck";
export default {
  name: "Details",
  data() {
    return {
      exhid: "",
      ExtID: "",
      limit: 30,
      headImg: "",
      page: 1,
      key: "",
      total: 0,
      proList: [],
      exData: {},
    };
  },
  created() {
    console.log("调用获取id的方法", this.$route.query);
    if (this.$route.query) {
      this.exhid = this.$route.query.exhid;
      this.ExtID = this.$route.query.ExtID;
      if (isMobileDevice()) {
        window.location.href = `https://hkh5.eainfor.com/#/pages/index/details?exhid=${this.$route.query.exhid}&ExtID=${this.$route.query.ExtID}`;
      }
      setTimeout(() => {
        this.fetchData();
        this.getProList();
        this.getImg();
      }, 0);
    }
  },
  mounted() {},
  methods: {
    fetchData() {
      let that = this;
      let url = `/Exh/exhibitorDetail/${that.exhid}?ExtID=${that.ExtID}`;
      this.$http
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("获取列表", res);
          this.exData = res.data.data;
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    //点击跳转展品详情
    bindProductDetails(item) {
      let that = this;
      this.$router.push({
        path: `/productDetail?exhid=${that.exhid}&EpID=${item.EpID}`,
      });
    },
    getImg() {
      let that = this;
      let url = `/Exh/resourceUrl/${that.exhid}?type=pcbanner`;
      this.$http
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("获取图片", res);
          that.headImg = res.data.data;
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    getProList() {
      let that = this;
      let url = `/Exh/extProductList/${that.exhid}?key=${that.key}&ExtID=${that.ExtID}&limit=${that.limit}&page=${that.page}`;
      this.$http
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("获取列表", res);
          that.proList = res.data.data.list;
          that.total = Number(res.data.data.count);
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background: #f6f6f6;
  position: absolute;
  width: 100%;
  min-height: 100%;
}

.bg {
  display: block;
  width: 100%;
}

.card {
  display: block;
  width: 100%;
  height: 255px;
  margin-top: 78px;
  background: url("../assets/bg2.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card_left {
    width: calc(32% - 56px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 56px;

    .logo {
      width: 200px;
      height: 200px;
      background: #ffffff;
      border-radius: 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #c4c4c4;
    }
  }

  .card_right {
    width: calc(67% - 56px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding-left: 56px;

    .name {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 24px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .sub_name {
      font-weight: 400;
      font-size: 19px;
      color: #333333;
      line-height: 24px;
      background: #e7f4fe;
      padding: 5px 10px;
      display: inline-block;

      margin: 14px 0 4px 0;
    }
  }
}

.introduce {
  width: 100%;
  background: #ffffff;
  padding-top: 23px;
  padding-bottom: 38px;
  margin: 30px auto;

  .title {
    font-weight: 600;
    font-size: 23px;
    color: #333333;
    line-height: 64px;
  }

  .sub_tit {
    font-weight: 400;
    font-size: 18px;
    white-space: pre-wrap;
    color: #999;
    line-height: 33px;
  }
}

.conteng {
}

.title {
  font-weight: 600;
  font-size: 23px;
  color: #333333;
  line-height: 64px;
}

.card_box2 {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 80px;
}

.card_row {
  width: 266px;
  height: 428px;
  background: #ffffff;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-right: 40px;
  cursor: pointer;

  .bor {
    width: 266px;
    height: 15px;
    background: #e2f2ff;
  }

  .logo {
    width: 260px;
    height: 199px;
    border-bottom: 1px solid #d1dbe5;
  }

  .card_right {
    padding-left: 10px;

    .name {
      font-weight: 600;
      font-size: 23px;
      color: #333333;
      line-height: 35px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 40px;
    }

    .sub_name {
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      line-height: 35px;
      display: inline-block;
    }

    .sub_name2 {
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 400;
      font-size: 18px;
      width: 240px;
      color: #999;
      line-height: 35px;
    }
  }
}
.card_row:nth-child(4n) {
  margin-right: 0px;
}
.card:nth-child(4) {
  margin-right: 0px;
}
</style>
